/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const authToken = localStorage.getItem("bearerToken");
  console.log(location);
  useEffect(() => {
    if (authToken) {
      navigate("/");
    }
  }, [authToken, navigate]);

  const handleButtonClick = () => {
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long.");
      return;
    }
    axios
      .post(`${process.env.REACT_APP_API_URL}/signup`, {
        email: email,
        password: password,
      })
      .then((res) => {
        console.log("Response from server:", res.data.data);
        navigate("/login");
        toast.success("User registered successfully!");
      })
      .catch((err) => {
        console.log("Error:", err);
        toast.error("Error registering user. Please try again.");
      });
  };

  const handleloginNavigate = () => {
    navigate("/login");
  };

  return (
    <>
      <div className="Login">
        <div className="leftlogin-content">
          <div className="login-maincont">
            <div className="login-tag">
              <h4 className="text-center">Register Now</h4>
            </div>
            <div className="input_Fieldss">
              <div className="input_Fieldss1">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input_Fieldss1" style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                </span>
              </div>
            </div>

            <div className="login_btn">
              <button className="log-btn" onClick={handleButtonClick}>
                Create account
              </button>
              <p>
                Already have an account?{" "}
                <span
                  id="log-in"
                  onClick={handleloginNavigate}
                  className="pointer text-orange-gradient"
                  style={{ textDecoration: "underline" }}
                >
                  Log In
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
